enum Locale {
    ru_RU = 'ru-RU'
}

export default Locale;
